"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastArrivalsSlider = void 0;
var react_1 = __importDefault(require("react"));
var CardAuto_1 = require("../cardAuto/CardAuto");
var react_2 = require("swiper/react");
var Loader_1 = require("../loader/Loader");
var useLastArrivalsSlider_1 = require("../../hook/useLastArrivalsSlider");
exports.LastArrivalsSlider = react_1.default.memo(function () {
    var _a = (0, useLastArrivalsSlider_1.useLastArrivals)(), lastArrivalsList = _a.lastArrivalsList, isLoading = _a.isLoading, error = _a.error, slidesPerView = _a.slidesPerView;
    if (isLoading) {
        return react_1.default.createElement(Loader_1.Loader, null);
    }
    if (error) {
        return react_1.default.createElement(react_1.default.Fragment, null, "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445");
    }
    return (react_1.default.createElement(react_2.Swiper, { className: "swiper-latest-arrivals", slidesPerView: slidesPerView, spaceBetween: 24 }, lastArrivalsList.map(function (car) { return (react_1.default.createElement(react_2.SwiperSlide, { key: car.id },
        react_1.default.createElement(CardAuto_1.CardAuto, __assign({}, car)))); })));
});
exports.default = exports.LastArrivalsSlider;
